import React from 'react'
import { connect } from 'react-redux'

const TextAreaInput = (props) => {
    const {
        input,
        label,
        placeHolder,
        require,
        disabled,
        meta: { touched, error }
    } = props

    return (
        <div className="w-full px-3">
            <label className="block  tracking-wide text-gray-800 font-bold text-sm  mb-2 text-left" >
                {label}
                {require ? <span className='ml-2 text-red-500 require'>*</span> : null}
                {touched && error ? <span className='ml-2 text-red-500 require'>{error}</span> : null}
            </label>
            <textarea
    style={{ backgroundColor: disabled ? "#3b3b3b0a" : touched && error ? "#FFF0F0" : "" , borderColor:'#FBC558', opacity:1, lineHeight:'1.2'}}
                {...input}
                className={` text-base appearance-none outline-none font-sukhumvit focus:outline-none block w-full 0 text-gray-800 border border-[#FBC558] rounded
                       py-3 px-4 mb-3 leading-tight `}
                type="text"
                disabled={disabled}
                placeHolder={placeHolder}
            />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = {

}


export default connect(mapStateToProps, mapDispatchToProps)(TextAreaInput)